/* eslint-disable @typescript-eslint/indent */
import { classNames, randomId } from '@pwskills/rachnaui/utils';
import { useRouter } from 'next/router';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { Close, Funnel } from '@pwskills/rachnaui/Icons';
import { Button, Container, Slider, Typography } from '@pwskills/rachnaui';
import { encodeSlugUrl } from '@/utils/helper/helperFunction';
import { ICourses } from '@/interfaces/homePage';
import {
  CategoryPageFilterPayload,
  ICategoryDetails,
  ICourseArrangement,
  ICourseMeta,
  // IDataLayerParam,
  IFilterApiPayload,
  // IFilterArrangement,
  IFiltersArrangement,
  IOfferingFilters,
} from '@/interfaces/courseListing';
import CourseListingApi from '@/api/courseListing';
import { Filter, IError } from '@/interfaces/common';
import { dataLayer } from '@/utils/common/dataLayer.utils';
import CourseCardRevamp from '@/components/common/CourseCardRevamp';
import LoadingCardRevampSkeleton from '@/components/common/LoadingSkeleton/LoadingCardRevampSkeleton';
import SortedFilterComponent from './SortedFilterComponent';
// import CoursesCard from '../../common/CoursesCard';
import Toaster from '../../common/Toaster';
import {
  LanguageEnum,
  Level,
  OptionLabel,
  PayloadKey,
  PayloadLabelValues,
  ProgramType,
} from '../../../interfaces/courseListing.enum';
import CategoryPageContext from '../../../context/CategoryPageContext';
import { useFilterContext } from '../../../context/FilterContext';

type Props = {
  categoriesArrangement?: ICourseArrangement[];
  categoryId: string;
};

const FreeOfferings = ({ categoriesArrangement, categoryId }: Props) => {
  const router = useRouter();
  const [courseMeta, setCourseMeta] = useState<ICourseMeta[]>();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFilterLoading, setIsFilterLoading] = useState<boolean>(false);
  const [coursesDetails, setCoursesDetails] = useState<ICourses[]>();
  const [category, setCategory] = useState<ICategoryDetails[]>([]);
  const [popError, setPopError] = useState<boolean>(false);
  const [isError, setIsError] = useState({
    status: false,
    message: '',
  });

  const [activeFilter, setActiveFilter] = useState<string[]>([]);
  const [offeringsFilterList, setOfferingsFilterList] = useState<IOfferingFilters[]>([]);
  const isFilterEmpty = useRef(false);

  // const [, setTotalPages] = useState<number>(1);
  const [isClearSelection, setIsClearSelection] = useState(false);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  // const [isApplyFilterLoading, setIsApplyFilterLoading] = useState(false);
  const [isPreviousCallLengthIsZero, setIsPreviousCallLengthIsZero] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [totalCourses, setTotalCourses] = useState<number>(0);
  const { categorySlug } = router.query;
  const { categoryDetails } = useContext(CategoryPageContext);
  const [filterType, setFilterType] = useState('tag');
  const sliderRef = useRef<null | HTMLDivElement>(null);
  const { filters, setFilter, deleteFilter, clearFilters } = useFilterContext();
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  // const [currentCourseIndex, setCurrentCourseIndex] = useState(1);
  // const [currentCourseNumber, setCurrentCourseNumber] = useState<number>(4);

  const level = {
    school_student: Level.SchoolStudent,
    college_student: Level.CollegeStudent,
    working_professional: Level.WorkingProfessional,
  };

  const programType = {
    live: ProgramType.Live,
    self_paced: ProgramType.SelfPacedCourses,
    campus_edge: ProgramType.CampusEdge,
    degree_programs: ProgramType.DegreePrograms,
    bootcamps: ProgramType.Bootcamps,
    trending: ProgramType.Trending,
    community: ProgramType.Community,
  };

  const LanguageType = {
    english: LanguageEnum.English,
    hinglish: LanguageEnum.Hinglish,
    hindi: LanguageEnum.Hindi,
  };

  const payloadLabel = {
    program: PayloadLabelValues.programType,
    level: PayloadLabelValues.level,
    domain: PayloadLabelValues.domains,
    category: PayloadLabelValues.categories,
    instructor: PayloadLabelValues.instructors,
    language: PayloadLabelValues.languages,
    sub_category: PayloadLabelValues.subcategories,
    subCategory: PayloadLabelValues.subcategories,
    pricing: PayloadLabelValues.isFree,
    search: PayloadLabelValues.text,
    tags: PayloadLabelValues.hashTag,
    categorySlug: PayloadLabelValues.filterConfigSlug,
  };

  const generatePayloadFromQuery = (): CategoryPageFilterPayload => {
    const payload: CategoryPageFilterPayload = {
      level: '',
      programType: '',
      text: '',
      instructors: [],
      categories: [],
      languages: [],
      subcategories: [],
      domains: [],
      isFree: '',
      hashTag: [],
      filterConfigSlug: '',
    };
    const queryObject = filters;

    Object.keys(filters).forEach((key) => {
      if (key === 'page') return;
      const queryObjectValue = queryObject[key];
      const payloadKey = payloadLabel[key as keyof typeof payloadLabel];
      if (Array.isArray(payload[payloadKey])) {
        if (Array.isArray(queryObjectValue)) {
          (payload[payloadKey] as string[]) = queryObjectValue;
        } else if (queryObjectValue) {
          (payload[payloadKey] as string[]).push(queryObjectValue as string);
        }
      } else if (payloadKey === 'text') {
        payload[payloadKey] = queryObjectValue as string;
      } else (payload[payloadKey] as string) = queryObjectValue as string;
    });
    return payload;
  };

  const checkIfAnyFilterIsApplied = (data: any) => {
    return Object.keys(data).some((key) => {
      if (key === PayloadKey.UNDEFINED) {
        return false;
      }
      // default keys
      if (key === PayloadKey.FILTER_CONFIG_SLUG) {
        return false;
      }
      // default keys
      if (key === PayloadKey.FILTER_CONFIG_SRC) {
        return false;
      }
      return (
        (typeof data[key] === 'string' && data[key] !== '') ||
        (data[key] !== '' && Array.isArray(data[key]) && data[key].length > 0)
      );
    });
  };

  const handleClearSelection = () => {
    setIsClearSelection(true);
    clearFilters();
    // getFilteredCourseData();
    setActiveFilter([]);
    setIsFilterApplied(false);
    setIsFiltersApplied(true);
    // setOpen(false);
  };

  const handleApplyFilter = () => {
    setFilterType('all_filter');
    setIsApplyFilter(true);
    setActiveFilter([]);
    setIsClearSelection(false);
    setIsFiltersApplied(true);
  };

  const getFilteredCourseData = async (pageNumber?: number) => {
    // show loading only on tile selection
    setIsLoading(true);
    setIsFilterLoading(true);
    setIsFiltersApplied(false);

    let filterSearchPayload = generatePayloadFromQuery();

    setIsFilterApplied(checkIfAnyFilterIsApplied(filterSearchPayload));

    try {
      filterSearchPayload = {
        ...filterSearchPayload,
        filterConfigSlug: categorySlug || '',
        filterConfigSrc: 'category_page_free',
        filterConfigCohortId: categoryId || '',
      };

      const response = await CourseListingApi.getFilteredCourse(
        filterSearchPayload as IFilterApiPayload,
        pageNumber ? Number(pageNumber) : 1,
        50
      );

      if (response) {
        const responseData = response?.data;
        if (responseData.courses.length > 0) {
          if (isPreviousCallLengthIsZero) {
            setIsApplyFilter(false);
            setIsPreviousCallLengthIsZero(false);
            setOpen(true);
          } else if (isClearSelection) {
            setOpen(false);
          } else {
            setOpen(false);
            setIsApplyFilter(false);
          }
        }
        if (responseData.courses.length === 0) {
          if (open) {
            setPopError(true);
            setIsError({
              message: 'No Course Found',
              status: false,
            });
            setIsPreviousCallLengthIsZero(true);
            handleClearSelection();
            if (isClearSelection) {
              setOpen(true);
            }

            if (isApplyFilter || isFilterEmpty.current) {
              router.push(`/${categorySlug}`).then(() => {
                setOpen(true);
              });
            }
          } else {
            setCoursesDetails(responseData?.courses);
            setActiveFilter([]);
          }
        }
        const courseMetaDetails = responseData?.meta;
        if (responseData.courses.length > 0) {
          setCoursesDetails(responseData?.courses);
          setTotalCourses(responseData.courses.length);
          // setTotalPages(courseMetaDetails[0].metadata[0].totalPages);
        }
        const offeringFilterDetails = responseData?.offeringFilters;
        setOfferingsFilterList(offeringFilterDetails);
        setCourseMeta(courseMetaDetails);
        setCategory(courseMetaDetails[0]?.category);
      }
      setIsLoading(false);
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
      setIsLoading(false);
    } finally {
      setIsFilterLoading(false);
    }
  };
  const mapCategoriesAndArrangement = () => {
    const dataLayerData = {} as Record<string, string>;
    const filterArrangement: IFiltersArrangement = {
      domain: {
        selectType: 'radio',
        filterType: 'Domain',
        filterOption: [],
        filterCount: 0,
      },
      categories: {
        selectType: 'checkbox',
        filterType: 'Category',
        filterOption: [],
        filterCount: 0,
      },
      subCategories: {
        selectType: 'checkbox',
        filterType: 'Sub Category',
        filterOption: [],
        filterCount: 0,
      },
      pricing: {
        selectType: 'radio',
        filterType: 'Pricing',
        filterOption: [],
        filterCount: 0,
      },
      profession: {
        selectType: 'radio',
        filterType: 'Filter by Profession',
        filterOption: [],
        filterCount: 0,
      },
      program: {
        selectType: 'radio',
        filterType: 'Program',
        filterOption: [],
        filterCount: 0,
      },
      language: {
        selectType: 'checkbox',
        filterType: 'Language',
        filterOption: [],
        filterCount: 0,
      },
      instructor: {
        selectType: 'checkbox',
        filterType: 'Instructor',
        filterOption: [],
        filterCount: 0,
      },
      level: {
        selectType: 'radio',
        filterType: 'Level',
        filterOption: [],
        filterCount: 0,
      },
      tags: {
        selectType: 'checkbox',
        filterType: 'Tags',
        filterOption: [],
        filterCount: 0,
      },
    };

    // create domain Arrangement
    categoriesArrangement?.forEach((arrangement: ICourseArrangement) => {
      if (arrangement.domainId) {
        category.forEach((categoryElement: ICategoryDetails) => {
          if (categoryElement.categoryDetails._id === arrangement.domainId) {
            dataLayerData[categoryElement.categoryDetails._id] =
              categoryElement.categoryDetails.title;
            filterArrangement.domain.filterOption.push({
              id: categoryElement.categoryDetails._id,
              count: categoryElement.coursesCount,
              slug: categoryElement.categoryDetails.slug,
              title: categoryElement.categoryDetails.title,
            });
          }
        });
      }
      arrangement.categories.forEach((categoryDetail) => {
        // create Category Arrangement
        if (categoryDetail.categoryId) {
          category.forEach((categoryElement: ICategoryDetails) => {
            if (categoryElement.categoryDetails._id === categoryDetail.categoryId) {
              dataLayerData[categoryElement.categoryDetails._id] =
                categoryElement.categoryDetails.title;
              filterArrangement.categories.filterOption.push({
                id: categoryElement.categoryDetails._id,
                count: categoryElement.coursesCount,
                title: categoryElement.categoryDetails.title,
                slug: categoryElement.categoryDetails.slug,
              });
            }
          });
        }

        // create Subcategory Arrangements
        categoryDetail.subCategories.forEach((subCategoryId) => {
          if (subCategoryId) {
            category.forEach((categoryElement: ICategoryDetails) => {
              if (categoryElement?.categoryDetails?._id === subCategoryId) {
                dataLayerData[categoryElement.categoryDetails._id] =
                  categoryElement.categoryDetails.title;
                filterArrangement?.subCategories.filterOption.push({
                  id: categoryElement?.categoryDetails._id,
                  count: categoryElement?.coursesCount,
                  title: categoryElement?.categoryDetails.title,
                  slug: categoryElement?.categoryDetails.slug,
                });
              }
            });
          }
        });
      });
    });

    courseMeta?.forEach((metadata) => {
      // Profession
      // if (metadata.levels) {
      //   metadata.levels.forEach((levelData) => {
      //     if (profession[levelData._id.level]) {
      //       filterArrangement.profession.filterOption.push({
      //         id: randomId(),
      //         count: levelData.coursesCount,
      //         title: profession[levelData._id.level],
      //         slug: encodeSlugUrl(levelData._id.level),
      //       });
      //     }
      //   });
      // }

      // level
      if (metadata.levels) {
        metadata.levels.forEach((levelData) => {
          if (level[levelData._id.level as keyof typeof level]) {
            filterArrangement.level.filterOption.push({
              id: randomId(),
              count: levelData.coursesCount,
              title: level[levelData._id.level as keyof typeof level],
              slug: encodeSlugUrl(levelData._id.level),
            });
          }
        });
      }

      // Tags
      if (metadata.hashTags) {
        metadata.hashTags.forEach((tagData) => {
          filterArrangement.tags.filterOption.push({
            id: randomId(),
            count: tagData?.coursesCount,
            title: tagData.tagName,
            // slug: encodeSlugUrl(languageData?.language),
            slug: tagData.tagSlug,
          });
        });
      }

      // Program type
      metadata.programType.forEach((program) => {
        if (
          program._id.programType &&
          programType[program._id.programType as keyof typeof programType]
        ) {
          filterArrangement.program.filterOption.push({
            id: randomId(),
            count: program.coursesCount,
            title: programType[program._id.programType as keyof typeof programType],
            slug: encodeSlugUrl(program._id.programType),
          });
        }
      });

      // Pricing Type
      metadata.pricing.forEach((pricing) => {
        filterArrangement.pricing.filterOption.push({
          id: randomId(),
          count: pricing.coursesCount,
          title: pricing._id.isFree === true ? PayloadKey.FREE : PayloadKey.PAID,
          slug: encodeSlugUrl(pricing._id.isFree === true ? 'true' : 'false'),
        });
      });

      // Language
      metadata.language.forEach((languageData) => {
        if (languageData.language) {
          filterArrangement.language.filterOption.push({
            id: randomId(),
            count: languageData?.coursesCount,
            title: LanguageType[languageData?.language as keyof typeof LanguageType],
            slug: encodeSlugUrl(languageData?.language),
          });
        }
      });

      // Instructor - Hidden as per SKIL-12739
      // metadata.instructors.forEach((instructorData) => {
      //   if (instructorData.instructorDetails.name) {
      //     dataLayerData[instructorData.instructorDetails._id] =
      //       instructorData.instructorDetails.name;
      //     filterArrangement.instructor.filterOption.push({
      //       id: instructorData.instructorDetails._id,
      //       count: instructorData?.coursesCount,
      //       title: instructorData.instructorDetails.name,
      //       slug: encodeSlugUrl(instructorData.instructorDetails.name),
      //     });
      //   }
      // });
    });

    return { filterArrangement, dataLayerData };
  };

  const checkIfUrlIsPresentInFilters = () => {
    const payloadFromRouter = generatePayloadFromQuery();
    Object.entries(payloadFromRouter).forEach(([key, value]) => {
      if (value.length > 0) {
        // check for category
        if (key === PayloadKey.CATEGORIES) {
          const categoryFilter = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.CATEGORY && item._id === value[0];
          });

          if (categoryFilter) setActiveFilter((prev) => [...prev, categoryFilter[0]?.title]);
          else setActiveFilter([]);
        }

        // check for subcategories
        else if (key === PayloadKey.SUBCATEGORIES) {
          const subCategory = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.SUB_CATEGORY && item._id === value[0];
          });
          if (subCategory) setActiveFilter((prev) => [...prev, subCategory[0]?.title]);
          else setActiveFilter([]);
        }

        // check for domain
        else if (key === PayloadKey.DOMAINS) {
          const domains = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.DOMAIN && item._id === value[0];
          });
          if (domains) setActiveFilter((prev) => [...prev, domains[0]?.title]);
          else setActiveFilter([]);
        }

        // check for tags
        else if (key === PayloadKey.HASHTAG) {
          const tagChoosen = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.TAGS && item._id === value[0];
          });
          if (tagChoosen) setActiveFilter((prev) => [...prev, tagChoosen[0]?.title]);
          else setActiveFilter([]);
        }

        // check for pricing
        else if (value !== '' && key === PayloadKey.ISFREE) {
          const pricing = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.PRICING && item._id === 'free'
              ? value === 'true'
              : item._id === 'paid'
              ? value === 'false'
              : null;
          });
          if (pricing) setActiveFilter((prev) => [...prev, pricing[0]?.title]);
          else setActiveFilter([]);
        }

        // check for programType
        else if (value !== '' && key === PayloadKey.PROGRAMTYPE) {
          const program = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.PROGRAM_TYPE && item._id === value;
          });
          if (program) setActiveFilter((prev) => [...prev, program[0]?.title]);
          else setActiveFilter([]);
        }

        // check for instructors
        else if (key === PayloadKey.INSTRUCTORS) {
          const instructor = offeringsFilterList.filter((item) => {
            return OptionLabel.INSTRUCTORS && item._id === value[0];
          });
          if (instructor) setActiveFilter((prev) => [...prev, instructor[0]?.title]);
          else setActiveFilter([]);
        }

        // check for level
        else if (value !== '' && key === PayloadKey.LEVEL) {
          const levelChoosen = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.PROFESSION && item._id === value;
          });
          if (levelChoosen) setActiveFilter((prev) => [...prev, levelChoosen[0]?.title]);
          else setActiveFilter([]);
        }

        // check for language
        else if (key === PayloadKey.LANGUAGES) {
          const language = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.LANGUAGE && item._id === value[0];
          });
          if (language) setActiveFilter((prev) => [...prev, language[0]?.title]);
          else setActiveFilter([]);
        }
      }
    });
    return null;
  };

  const checkFlagPresentInUrl = () => {
    const isFlagPresent = filters.isFilterChecked === true;
    return isFlagPresent;
  };

  const sendDataLayerEvent = (filtersUsed: Filter[]) => {
    const dataLayerObj = {
      event: 'filter_used',
      filter_used: filtersUsed,
      section_name: 'category_free_course',
      filter_type: filterType,
    };
    dataLayer(dataLayerObj);
  };

  const checkAnyFilterApplied = () => {
    const payload = generatePayloadFromQuery();
    const filtersUsed: Filter[] = [];
    Object.entries(payload).forEach(([key, value]) => {
      if (
        value.length > 0 &&
        key !== PayloadKey.UNDEFINED &&
        key !== PayloadKey.FILTER_CONFIG_SRC &&
        key !== PayloadKey.FILTER_CONFIG_SLUG
      ) {
        filtersUsed.push({ [key]: value });
      }
    });

    if (filtersUsed.length > 0) {
      sendDataLayerEvent(filtersUsed);
    } else {
      setActiveFilter([]);
    }
    if (filtersUsed.length > 0) return true;
    return false;
  };

  useEffect(() => {
    // to rest the scroller to 0
    sessionStorage.setItem('scrollPosition', '0');

    const handleRouteChange = () => {
      // Save the current scroll position when navigating
      sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []);

  useEffect(() => {
    // Restore the scroll position when the component mounts
    const scrollPosition: any = sessionStorage.getItem('scrollPosition') || 0;
    window.scrollTo(0, parseInt(scrollPosition, 10));
  }, [router]);

  useEffect(() => {
    if (!checkFlagPresentInUrl()) {
      getFilteredCourseData();
      // sendDataLayerEvent();
      checkAnyFilterApplied();
      // handleScrollToOfferingSection('course-listing-section');
    }
  }, []);

  useEffect(() => {
    checkIfUrlIsPresentInFilters();
  }, [offeringsFilterList]);

  useEffect(() => {
    mapCategoriesAndArrangement();
  }, [categoriesArrangement, category]);

  useEffect(() => {
    getFilteredCourseData();
    // setCurrentCourseIndex(1);
  }, [isFiltersApplied]);

  const handleFilterClick = (slug: string, optionLabel: string, id: string) => {
    setFilterType('tag');
    setIsApplyFilter(true);
    setIsFiltersApplied(true);
    let queryParams: string;
    let updatedId: string | boolean = id;
    if (optionLabel === OptionLabel.PROFESSION) {
      queryParams = PayloadKey.LEVEL;
    } else if (optionLabel === OptionLabel.PROGRAM_TYPE) {
      queryParams = PayloadKey.PROGRAM;
    } else if (optionLabel === OptionLabel.INSTRUCTORS) {
      queryParams = PayloadKey.INSTRUCTOR;
    } else if (optionLabel === OptionLabel.PRICING) {
      queryParams = PayloadKey.PRICING;
      if (id === PayloadKey.FREE) {
        updatedId = true;
      } else {
        updatedId = false;
      }
    } else {
      queryParams = optionLabel;
    }

    if (!activeFilter.includes(slug)) {
      setIsLoading(true);
      setActiveFilter([slug]);
      const value = filters[queryParams] === updatedId ? null : updatedId;
      clearFilters();
      setFilter(queryParams, value);
    } else {
      setActiveFilter([]);
      deleteFilter(queryParams);
    }
    // getFilteredCourseData();
  };

  // this use effect will load when there are no filters in the meta - all filters
  useEffect(() => {
    if ((coursesDetails?.length === 0 || coursesDetails === undefined) && open) {
      isFilterEmpty.current = true;
      getFilteredCourseData();
    }
  }, [coursesDetails, open]);

  return (
    <div>
      {totalCourses > 0 && (
        <Container className="py-8 large:!py-14 large:!px-16 flex flex-col">
          <section id="course-listing-section" data-title="course-listing-section">
            <div>
              <div className="flex flex-col gap-1 large:!gap-4">
                <div>
                  <Typography
                    component="h2"
                    variant="bold"
                    className="text-gray-400 font-inter medium:!text-[32px] large:!text-[48px] leading-[2rem] medium:!leading-[44px]"
                  >
                    Jumpstart Your Learning With
                  </Typography>
                </div>
                <div>
                  <Typography
                    component="h2"
                    variant="bold"
                    className="text-gray-850 font-inter medium:!text-[32px] large:!text-[48px] leading-[2rem] medium:!leading-[44px]"
                  >
                    Our Free Offerings
                  </Typography>
                </div>
              </div>

              <div className="flex justify-between items-end gap-[29px]">
                <div className="flex flex-row gap-x-6 overflow-x-auto items-center justify-between mt-6 large:!mt-14 w-full">
                  <div
                    className="flex flex-row gap-x-6 overflow-x-auto"
                    style={{ scrollbarWidth: 'none' }}
                  >
                    {offeringsFilterList.map((item) => {
                      // Hide instructor tabs - SKIL-12739
                      if (item.type === OptionLabel.INSTRUCTORS) {
                        return null;
                      }
                      if (item?.coursesCount > 0) {
                        return (
                          <Button
                            key={item._id} // Ensure each button has a unique key
                            variant="secondary"
                            className={`hover:bg-gray-100 !w-auto !px-4 whitespace-nowrap min-w-fit !text-gray-850 bg-white font-extrabold large:!font-bold rounded-lg !text-[14px] !border !border-[#EFEFEF] !py-[11px] ${
                              activeFilter.includes(item?.title)
                                ? 'bg-[#FFF0ED] !border-[#E9A091] hover:!bg-[#FFF0ED]'
                                : 'bg-white !border-[#EFEFEF]'
                            }`}
                            onClick={() => handleFilterClick(item?.title, item?.type, item?._id)}
                          >
                            <Typography
                              variant="bold"
                              component="body-small"
                              className="min-w-[160px]"
                            >
                              {item?.title}
                            </Typography>
                          </Button>
                        );
                      }
                      return null;
                    })}
                  </div>

                  <Button
                    variant="tertiary"
                    className={`whitespace-nowrap min-w-fit !text-gray-850 font-extrabold large:!font-bold rounded-none !text-[14px] !py-[11px] !px-4 hidden large:!block large:!w-[180px] ${
                      isFilterApplied
                        ? '!border !border-orange-500 bg-[#FFF0ED] hover:bg-[#FFF0ED]'
                        : '!text-gray-850 bg-[#f8f8f8] !border-l-[1px] !border-[#B7B7B7] hover:bg-[#EAECEF]'
                    }`}
                    onClick={() => setOpen(true)}
                  >
                    All Filters
                  </Button>
                  <div className="bg-orange-50 rounded-[50%] p-1 h-8 min-w-[32px] flex large:!hidden justify-center items-center cursor-pointer">
                    <Funnel className="text-orange-500 w-4 h-4" onClick={() => setOpen(true)} />
                  </div>
                </div>
              </div>

              <div>
                {coursesDetails?.length === 0 && !isLoading ? (
                  <div className="flex flex-col items-center justify-center w-full">
                    <img
                      src="/images/courseListing/noCourseFound.gif"
                      alt="no-course-found"
                      className="w-[320px] h-[320px]"
                      width={320}
                      height={320}
                    />
                    <Typography
                      variant="semi-bold"
                      component="body-regular"
                      className="text-center text-[16px] text-gray-850"
                    >
                      No Course Found
                    </Typography>
                  </div>
                ) : (
                  <div id="sliders" ref={sliderRef} className="pt-8 medium:!pt-6 min-h-[500px]">
                    <Slider
                      className={classNames(
                        '!gap-2 medium:!gap-x-[22px] [&>div]:mr-2 [&>*:last-child]:mr-0 !mx-auto [&>div]:large:ml-4 !pt-4 !pl-2'
                      )}
                      positionOfSliderInMobile="bottom"
                    >
                      {isLoading
                        ? Array(4)
                            .fill(randomId())
                            .map(() => <LoadingCardRevampSkeleton isButtonSkeleton />)
                        : coursesDetails &&
                          coursesDetails.map((filteredCourse, index) => (
                            <CourseCardRevamp
                              course={filteredCourse}
                              key={filteredCourse?._id}
                              pageFrom="category_page"
                              section="category_free_course"
                              categorySlug={categoryDetails?.slug}
                              categoryName={categoryDetails?.title}
                              categoryId={categoryDetails?._id}
                              position="category_page_free_offering"
                              cardPosition={index + 1}
                              courseType="free"
                            />
                          ))}
                    </Slider>
                  </div>
                )}
              </div>
            </div>

            {open && (
              <>
                <div className="h-screen w-screen fixed bg-black opacity-50 top-0 z-[99998] left-0" />
                <div
                  id="slider"
                  className={classNames(
                    'flex flex-col z-[99999] fixed bottom-0 !w-full medium:!w-[75%] medium:!mx-auto h-[85%] large:!w-[40%] large:!right-0 left-0 large:!left-auto medium:!right-0 slide-in bg-white shadow-medium py-6 px-8 medium:h-screen rounded-t-2xl duration-300 transition-all',
                    open ? 'scale-100' : 'scale-0 pointer-events-none'
                  )}
                >
                  <div
                    className={classNames(
                      'flex justify-between gap-x-2 items-center pb-3',
                      'border-b'
                    )}
                  >
                    <div className="flex gap-2 border-stroke-200 sticky top-0 items-center">
                      <Typography
                        component="h3"
                        variant="bold"
                        className={classNames('cursor-default')}
                      >
                        Filters
                      </Typography>
                    </div>
                    <div className="ml-auto p-2 bg-[#EAECEF] rounded-full">
                      <Close
                        onClick={() => {
                          setOpen(false);
                          setIsClearSelection(false);
                        }}
                        className="cursor-pointer"
                      />
                    </div>
                  </div>

                  <div
                    className="flex flex-col !gap-6 medium:!gap-10 h-[100vh] medium:!h-[85vh] large:!h-[75vh] overflow-y-scroll pb-8"
                    style={{ scrollbarWidth: 'none' }}
                    onScroll={(e) => e.stopPropagation()}
                  >
                    <SortedFilterComponent
                      filteredData={mapCategoriesAndArrangement()}
                      activeFilter={activeFilter}
                      isLoading={isFilterLoading}
                    />
                  </div>

                  {popError && (
                    <Toaster
                      open={popError}
                      setOpen={setPopError}
                      text={isError.message}
                      variant={isError.status ? 'success' : 'error'}
                    />
                  )}

                  <div className="flex flex-row absolute left-0 medium:!left-auto !w-full bottom-0 medium:!mb-6 medium:!justify-end medium:!w-fit medium:!self-end medium:!gap-2 bg-white shadow-medium">
                    <Button
                      variant="low-focus"
                      className="bg-white !rounded py-3 px-10 !w-1/2 medium:!w-fit border !border-[#EFEFEF] !text-gray-650 !font-bold whitespace-nowrap"
                      disabled={!checkIfAnyFilterIsApplied(generatePayloadFromQuery())}
                      onClick={handleClearSelection}
                      size="small"
                    >
                      Clear Selection
                    </Button>
                    <Button
                      variant="primary"
                      className="!rounded py-3 px-10 !font-bold !w-1/2 medium:w-fit"
                      disabled={!checkIfAnyFilterIsApplied(generatePayloadFromQuery())}
                      onClick={handleApplyFilter}
                      size="small"
                    >
                      Apply Filters
                    </Button>
                  </div>
                </div>
              </>
            )}
          </section>
        </Container>
      )}
    </div>
  );
};

export default FreeOfferings;
